import React, { FC, useCallback, useMemo } from 'react';
import ImportGridModal from '../ow_flatfile/ImportGridModal';
import {
	getReceivedEquipmentFlatfileHeader,
	PARTIAL_UPLOAD_CRUD_FIELD,
	getFlatfileRecordForReceivedEquipmentExport,
} from '../stock_locations_detail_details_page/stock_location_constants';
import { CSV_EXPORT_DEFAULTS } from '../../utils/DataConstants';
import { ExportToCsv } from 'export-to-csv';
import { requiredWithValueRecordHook } from '../ow_flatfile/import_record_hooks';

const PartialEPSLUpload: FC<any> = ({
	hideUploadPopup,
	allEquipmentTypesNames,
	allVendorNames,
	onDataUpload,
	recordHook,
}): React.ReactElement => {
	const FLATFILE_HEADER_WITH_CRUD_ACTION = useMemo(
		() => [
			PARTIAL_UPLOAD_CRUD_FIELD,
			...getReceivedEquipmentFlatfileHeader(allEquipmentTypesNames, allVendorNames),
		],
		[allEquipmentTypesNames, allVendorNames]
	);

	const onDownloadSample = useCallback(() => {
		const csvTitle = `Partial_Equipment_Upload_Sample`;
		const csvExporter = new ExportToCsv({
			...CSV_EXPORT_DEFAULTS,
			filename: csvTitle,
			title: csvTitle,
			headers: FLATFILE_HEADER_WITH_CRUD_ACTION.map((_) => _.label),
		});

		const data = [
			{
				crudAction: 'create',
				...getFlatfileRecordForReceivedEquipmentExport({}),
			},
			{
				crudAction: 'update',
				...getFlatfileRecordForReceivedEquipmentExport({ id: 1234 }),
			},
			{
				crudAction: 'delete',
				...getFlatfileRecordForReceivedEquipmentExport({ id: 4567 }),
			},
		];
		csvExporter.generateCsv(data);
	}, [FLATFILE_HEADER_WITH_CRUD_ACTION]);

	const updatedRecordHook = (record) => {
		const updatedRecord = recordHook ? recordHook(record) : record;
		return requiredWithValueRecordHook(['id'], 'crudAction', ['update', 'delete'])(updatedRecord);
	};

	return (
		<ImportGridModal
			visible
			title="Partial Equipment Upload"
			sampleModalText="Do you want to download Sample?"
			sampleButtonText="Download Sample"
			recordHook={updatedRecordHook}
			onCancel={hideUploadPopup}
			onDownloadSample={onDownloadSample}
			fields={FLATFILE_HEADER_WITH_CRUD_ACTION}
			onDataLoad={onDataUpload}
			onComplete={hideUploadPopup}
		/>
	);
};

export default PartialEPSLUpload;
